import { render } from "./OfferView.vue?vue&type=template&id=1dfa4dd7"
import script from "./OfferView.vue?vue&type=script&lang=js"
export * from "./OfferView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__